<template lang="pug">
    v-main.blue-grey.darken-3(style="height:100%;")
        v-layout(v-if="estado === 'verificando'" align-center fill-height justify-center)
            v-card(color="transparent" dark style="width:400px;" flat)
                v-card-text
                    div.text-xs-center
                        v-progress-circular(indeterminate color="blue" size="54")
                        p.text-loader Verificando codigo:
                        p.text-code {{ codigo }}
        v-layout(v-else-if="estado === 'verificado'" justify-center)
            v-card(color="transparent" flat dark style="width:100%;margin:15px;line-height:0px;")
                v-card-text
                    p.text-xs-center.text-loaded El codigo: <b>{{ codigo }}</b> pertenece al siguiente documento:
                v-divider
                v-card-text.no-padding
                    //- pdf.custom-iframe(:src="urlFile" width="100%" :height="windowH")
                    iframe.custom-iframe(:src="urlFile" width="100%" :height="windowH")
        v-layout(v-else align-center fill-height justify-center)
            v-card(color="transparent" dark style="width:400px;" flat)
                v-card-text
                    div.text-xs-center
                        v-avatar(size="80" color="white")
                            v-icon(style="font-size:84px" color="red") highlight_off
                        p.text-loader El codigo no pertenece a ningun documento
</template>

<style lang="stylus">
    .text-loader
        padding-top 15px
        font-size 18px
    .text-code
        margin-top -22px
        font-size 26px
    .custom-iframe
        border none
</style>


<script>
export default {
    data: () => {
        return {
            codigo: '',
            estado: 'verificando',
            urlFile: '',
            progressVerification: false
        };
    },
    computed: {
        windowH: function() {
            return this.$store.state.windowSize.h -80
        }
    },
    methods: {
        verifyCode: function() {
            return axios({
                method: 'POST',
                url: '/service/service-file-manager/api/v1/verify-code-report/',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                data: {
                    code: this.codigo
                }
            }).then((function(response) {
                if (response.data.status === 'success') {
                    this.estado = 'verificado';
                    return this.urlFile = response.data.link;
                } else {
                    return this.estado = 'none';
                }
            }).bind(this))["catch"]((function(error) {
                return console.log(error);
            }).bind(this));
        }
    },
    created: function() {
        var run;
        this.codigo = this.$route.params.code;
        run = (function() {
            return this.verifyCode();
        }).bind(this);
        return setTimeout(run, 3000);
    }
};
</script>